import { useIsAdminUser } from "@mirage/service-auth/useDropboxAccount";
import { useNotificationsLastSeen } from "@mirage/service-dash-trial/hooks/useNotificationsLastSeen";
import { useAtom } from "jotai";
import { useCallback } from "react";
import { trialActivityAtom, trialEndingNotificationAtom } from "./atoms";
import { TrialActionType } from "./types";
import { getActionSurface, useLogShownUpsellComponent } from "./utils";

export const TRIGGER_SERP_UPSELL_AFTER_DAYS_LEFT = 15;
export const DAY_COOLDOWN = 2; // we only want to show the serp upsell once every two days

export const useSerpTrialUpsell = () => {
  const [trialEndingNotification, setTrialEndingNotification] = useAtom(
    trialEndingNotificationAtom,
  );

  const { setLastSeen, lastSeenSerpNotification } = useNotificationsLastSeen();
  const { daysLeft } = trialEndingNotification;
  const [trialActivity, setTrialActivity] = useAtom(trialActivityAtom);
  const logShownUpsell = useLogShownUpsellComponent();
  const isAdmin = useIsAdminUser();

  const lastSearchDate = trialActivity.lastSearchDate; // has the user ever searched before?
  const serpTriggerTrialUpsellCheck = useCallback(() => {
    if (
      lastSearchDate &&
      daysLeft <= TRIGGER_SERP_UPSELL_AFTER_DAYS_LEFT &&
      daysLeft <= lastSeenSerpNotification - DAY_COOLDOWN
    ) {
      setTrialEndingNotification((prev) => ({
        ...prev,
        isVisible: true,
        actionType: TrialActionType.Search,
      }));
      setLastSeen({ serp: daysLeft });
      setTrialActivity((prev) => ({
        ...prev,
        lastSearchDate: Date.now(),
      }));
      logShownUpsell({
        actionSurface: getActionSurface(TrialActionType.Search),
        ctaName: isAdmin ? "view_plans" : "ask_your_admin",
      });
    }

    if (!lastSearchDate) {
      setTrialActivity((prev) => ({
        ...prev,
        lastSearchDate: Date.now(),
      }));
    }
  }, [
    daysLeft,
    lastSeenSerpNotification,
    lastSearchDate,
    setTrialEndingNotification,
    setLastSeen,
    setTrialActivity,
    logShownUpsell,
  ]);

  const isTrialNotificationVisible = trialEndingNotification.isVisible;

  return {
    isTrialNotificationVisible,
    serpTriggerTrialUpsellCheck,
  };
};
